import setupSetup from "./setupSetup";
const setupFetch = setupSetup("PUT");
export default setupFetch;
